import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { AskMoreAboutProductDropdown } from 'autogen/translation-keys/trans-website-comai';
import { Typography } from 'components/generic/typography';
import Icon from 'components/Icon/Icon';

const StyledDetails = styled.details`
    display: flex;
    flex-direction: column;

    &[open] {
        gap: ${({ theme }) => theme.Spacing16};
    }

    & #dropdownSummeryIcon {
       transition: transform 200ms ease-in-out;
    }

    &[open] #dropdownSummeryIcon {
       transform: rotateZ(-180deg);
    }
`;

const StyledSummary = styled.summary`
    cursor: pointer;
    font-weight: bold;
    display: flex;
    align-items: center;
    gap: 8px;
`;

type DropdownProps = {
    children?: React.ReactNode;
};

export default function Dropdown(props: DropdownProps) {
    const { children } = props;
    const { t } = useTranslation();

    return (
        <StyledDetails>
            <StyledSummary>
                <Typography.Body strong>{t(AskMoreAboutProductDropdown)}</Typography.Body>
                <Icon id="dropdownSummeryIcon" type="ChevronDown" size={16} />
            </StyledSummary>
            {children}
        </StyledDetails>
    );
}
